import { useEffect, useMemo, useState } from 'react';
import { useAuth } from '@/shared/contexts/AuthContext';
import { getCharacters, type Character } from '@/shared/services/characterService';
import { getActiveTier } from '@/shared/lib/premiumTiers';
import { NATION_NAME, useNextWar } from '@/shared/lib/war';
import { AccountStrip } from './summary/AccountStrip';
import { DashStats } from './summary/DashStats';
import { GiftsPanel } from './summary/GiftsPanel';
import { ReferralPanel } from './summary/ReferralPanel';
import { AchievementsPanel } from './summary/AchievementsPanel';
import { DashboardCta } from './summary/DashboardCta';
// Fora de uso por enquanto (pedido do dono) — ver o bloco comentado no JSX:
// import { getNews } from '@/shared/services/eventsService';
// import { getRankingHome } from '@/shared/services/rankingService';
// import { CharactersPanel } from './summary/CharactersPanel';
// import { RadarPanel } from './summary/RadarPanel';

export default function DashboardPage() {
  const { account, cash, premium, refreshCash } = useAuth();
  const war = useNextWar();
  const [characters, setCharacters] = useState<Character[] | null>(null);

  useEffect(() => {
    getCharacters().then(setCharacters).catch(() => setCharacters([]));
  }, []);

  const premiumDays = premium?.expireDate
    ? Math.max(0, Math.ceil((new Date(premium.expireDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
    : 0;
  const tier = getActiveTier(premium?.serviceKind, premiumDays);

  const chars = characters ?? [];
  // Principal = o de maior nivel da conta (nacao exibida nas tags).
  const main = useMemo(() => chars.reduce<Character | null>((best, c) => (!best || c.lev > best.lev ? c : best), null), [chars]);

  const tags = [
    `${chars.length} ${chars.length === 1 ? 'personagem' : 'personagens'}`,
    tier.isPaid ? `Premium ${tier.name}` : 'Sem premium',
    NATION_NAME[main?.nation ?? 0] || 'Sem nação',
  ];

  return (
    <div className="lb-summary">
      <div className="dashboard-heading">
        <p className="dashboard-kicker">Painel do jogador</p>
        <h1>Resumo</h1>
      </div>

      {account && <AccountStrip account={account} tags={tags} />}

      <DashStats
        characters={characters ? chars.length : null}
        cash={cash?.cash ?? 0}
        premiumName={tier.name}
        premiumNote={tier.isPaid ? `${premiumDays} dias restantes` : 'sem premium ativo'}
        nextWar={war.short}
      />

      {/* "Seus Personagens" + "Radar do Servidor" — desligados por enquanto (pedido do dono).
          Pra religar: descomentar os imports acima, estes estados e o bloco.
      const [featured, setFeatured] = useState('—');
      const [lastWinner, setLastWinner] = useState('—');
      getNews().then((n) => setFeatured(n[0]?.title || '—'));
      getRankingHome().then((r) => setLastWinner(NATION_NAME[r?.nation?.victoryNation] || '—'));
      <section className="dashboard-main-grid">
        <CharactersPanel characters={chars} main={main} />
        <RadarPanel rows={[
          { label: 'Evento em destaque', value: featured },
          { label: 'Última guerra vencida', value: lastWinner },
          { label: 'Status da conta', value: 'Ativa' },
          { label: 'Recomendação', value: 'Complete o cadastro' },
        ]} />
      </section>
      */}

      <GiftsPanel cash={cash?.cash ?? 0} pending={cash?.cashPending ?? 0} onBought={refreshCash} />
      <ReferralPanel />

      {/* Conquistas Liberty — contas do closed beta */}
      {account && account.userNum <= 334 && <AchievementsPanel playTime={440} />}

      <DashboardCta />
    </div>
  );
}
